import { Skeleton } from "@repo/skapa";
import { TranslationProvider } from "@repo/translation";
import { SettingsProvider } from "@repo/ui";
import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";

import { SubHeaderTabs } from "./SubHeaderTabs";
import { useSubHeaderConfig } from "./useSubHeaderConfig";

export function SubHeaderApp({ onTabsLoaded }: { onTabsLoaded?: () => void }) {
  const { enabledTabs, activeTabPanelId, isLoading } = useSubHeaderConfig();
  const [isVisible, setIsOpen] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(true);
  useEffect(() => {
    const tryRegister = (retries = 10) => {
      const callback = window.salja?.salesLead?.registerSubHeaderCallback;
      if (callback) {
        callback((isShow: boolean) => setIsOpen(isShow));
      } else if (retries > 0) {
        setTimeout(() => tryRegister(retries - 1), 100);
      }
    };

    tryRegister();
  }, []);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (!isLoading) {
      timer = setTimeout(() => {
        setShowSkeleton(false);
        onTabsLoaded?.();
      }, 300);
    }
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  if (isLoading || showSkeleton) {
    return <Skeleton height="50px" width="100%" />;
  }

  return isVisible ? (
    <TranslationProvider>
      <SettingsProvider>
        <BrowserRouter>
          <SubHeaderTabs
            tabs={enabledTabs}
            activeTabPanelId={activeTabPanelId}
          />
        </BrowserRouter>
      </SettingsProvider>
    </TranslationProvider>
  ) : null;
}
